export default "__VITE_ASSET__$dLgb$XK__"